import { createSelector } from 'reselect';

const selectRelatedToTypes = (state: any) => state.relatedToTypes;


export const selectRelatedToTypesCurrentItem = createSelector([selectRelatedToTypes], (relatedToTypes) => relatedToTypes.current);

export const selectRelatedToTypesListItems = createSelector([selectRelatedToTypes], (relatedToTypes) => relatedToTypes.list);

export const selectRelatedToTypesItemById = (itemId: any) =>
    createSelector(selectRelatedToTypesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectRelatedToTypesQueryItems = createSelector([selectRelatedToTypes], (relatedToTypes) => relatedToTypes.query);

export const selectRelatedToTypesCreatedItem = createSelector([selectRelatedToTypes], (relatedToTypes) => relatedToTypes.create);

export const selectRelatedToTypesUpdatedItem = createSelector([selectRelatedToTypes], (relatedToTypes) => relatedToTypes.update);

export const selectRelatedToTypesReadItem = createSelector([selectRelatedToTypes], (relatedToTypes) => relatedToTypes.read);

export const selectRelatedToTypesDeletedItem = createSelector([selectRelatedToTypes], (relatedToTypes) => relatedToTypes.delete);

export const selectRelatedToTypesSearchedItems = createSelector([selectRelatedToTypes], (relatedToTypes) => relatedToTypes.search);

export const selectRelatedToTypesItemsCount = createSelector([selectRelatedToTypes], (relatedToTypes) => relatedToTypes.count);

export const selectRelatedToTypesItemsFilter = createSelector([selectRelatedToTypes], (relatedToTypes) => relatedToTypes.filter);